/**
 * PKCE + state helpers — mirrors g1-ads/apps/spa/src/lib/pkce.ts
 * (base64url, S256 challenge, random verifier/state) for the browser.
 */

function base64url(bytes: Uint8Array): string {
	let s = "";
	for (const byte of bytes) s += String.fromCharCode(byte);
	return btoa(s).replaceAll("+", "-").replaceAll("/", "_").replaceAll("=", "");
}

function randomBytes(n: number): Uint8Array {
	const b = new Uint8Array(n);
	crypto.getRandomValues(b);
	return b;
}

export function newVerifier(): string {
	return base64url(randomBytes(48));
}

export async function challengeS256(verifier: string): Promise<string> {
	const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
	return base64url(new Uint8Array(digest));
}

export function newState(): string {
	return base64url(randomBytes(24));
}
